<template>
    <div class="row m-0">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3 px-2 my-4"
            v-for="item in sortedContendersList" :key="item.id">
            <div class="c-contestant__card text-center border-0 position-relative">
                <div class="c-contestant__card-header card-header p-0">
                    <img :src="item.ImageUrl" alt="alt text" class="card-img" />
                </div>
                <div class="card-body pb-0 px-0">
                    <h4 class="mb-0">
                        <a :href="item.PageUrl" class="c-contestant__card-title text-bold">
                            {{ item.fullName }}
                        </a>
                    </h4>
                    <p class="card-text m-0 pt-2 c-contestant__card-description">
                        {{ item.NomineeTitle }}
                    </p>
                </div>
                <div class="c-contestant__card-footer card-footer py-0">
                    <p class="mt-1 mb-0 c-contestant__card-votes-count" v-if="item.VoteTotal">
                        {{ item.VoteTotal }} {{ item.VoteTotal === 1 ? voteText : votesText }}
                    </p>
                    <a :href="item.PageUrl" class="btn btn-round btn-outline-primary mt-3"
                        :aria-label="`${item.VoteNowFor}`"
                        v-if="item.VoteAllowed">
                        {{ voteNowLabel }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContestantGrid',
    props: {
        contendersList: Array,
        search: String,
        currentPageNo: Number,
        voteNowLabel: String,
        votesText: String,
        voteText: String,
        showNumberOfContendersPerPage: Number,
    },
    computed: {
        sortedContendersList () {
            const filtedByContendersName = this.contendersList.filter(item => {
                return item.fullName.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            })
            this.setNumberOfPages(filtedByContendersName);
            const filtedByPerPageContenders = filtedByContendersName.filter((row, index) => {
                const from = (this.currentPageNo * this.showNumberOfContendersPerPage) - this.showNumberOfContendersPerPage;
                const to = (this.currentPageNo * this.showNumberOfContendersPerPage);
                if(index >= from && index < to) return true;
            });
            this.$emit('updatedSearchedResults', filtedByContendersName);
            return filtedByPerPageContenders;
        }
    },
    methods: {
        setNumberOfPages (filtedByContendersName) {
            const numberOfPagesArray = [];
            let currentActivePage = this.currentPageNo;
		    let numberOfPages = Math.ceil(filtedByContendersName.length / this.showNumberOfContendersPerPage);
		    for (let index = 1; index <= numberOfPages; index++) {
			    numberOfPagesArray.push(index);
		    }
            if (numberOfPagesArray.length < currentActivePage) {
                currentActivePage = 1;
            }
            this.$emit('getPaginationDetails', { currentActivePage, numberOfPagesArray });
	    },
    },
}
</script>



// WEBPACK FOOTER //
// src/app/components/contestant-grid.vue